import { ITripRequestLogOutputDto } from './trip-request-log-output-dto.interface';
import { TripRequestLogSource } from '../enums/trip-request-log-source.enum';
import { TripRequestLogStatus } from '../enums/trip-request-log-status.enum';

export interface IGroupedTripRequestLogOutputDto {
    tripCode: string;
    tripDefinitionName?: string;
    lastTimestamp: Date;
    status: TripRequestLogStatus;
    requestsCount: number;
    successRequestsCount: number;
    failedRequestsCount: number;
    userName?: string;
    apiKey?: string;
    source?: TripRequestLogSource;
    requests: ITripRequestLogOutputDto[];
}
